import { Button, Form, Input, notification, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { FaUpload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { ORANGE } from '../../../../shared/colors';
import { createDetenteur, updateDetenteur } from '../network';

export const ClientForm = ({
  clientToUpdate,
  setShowDrawer,
  getNewClient,
}: {
  clientToUpdate?: DetenteurEntity;
  setShowDrawer: (b: boolean) => void;
  getNewClient: (part: DetenteurEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!clientToUpdate) {
      form.resetFields();
    } else {
      form.setFieldsValue(clientToUpdate);
    }
  }, [clientToUpdate, form]);

  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        initialValues={clientToUpdate}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          if (clientToUpdate === undefined) {
            // new detenteur
            data.partenaire = connectedUser.partenaire.url;
            data.agence = connectedUser.agence.url;
            data.asset_manager = connectedUser.manager.url;
            data.createur = connectedUser.url;
            data.piece_identite =
              data.piece_identite?.fileList[0]?.originFileObj;

            await createDetenteur(data).then(({ data, statusCode }) => {
              if (statusCode?.toString()[0] === '2') {
                notification.success({
                  message: 'Succès',
                  description: 'Le client a été créé avec succès',
                });
                getNewClient(data);
                setShowDrawer(false);
              } else {
                notification.info({
                  message: 'Erreur',
                  description: data.message,
                });
              }
              setIsLoading(false);
            });
          } else {
            // update detenteur

            const { piece_identite, ...dataToUpdate } = data;
            await updateDetenteur(clientToUpdate.url, dataToUpdate).then(
              ({ data, statusCode }) => {
                if (statusCode?.toString()[0] === '2') {
                  notification.success({
                    message: 'Succès',
                    description: 'Le client a été créé avec succès',
                  });
                  setShowDrawer(false);
                } else {
                  notification.info({
                    message: 'Erreur',
                    description: data.message,
                  });
                }
                setIsLoading(false);
              },
            );
            setIsLoading(false);
          }
        }}
      >
        {!clientToUpdate && (
          <Form.Item
            label='Code référent'
            name='code_referent'
            rules={[
              {
                required: true,
                message: 'Entrez le code référent du client',
              },
            ]}
            style={{ marginBottom: 5 }}
          >
            <Input placeholder='Entrez le code référent du client' />
          </Form.Item>
        )}
        <Form.Item
          label='Nom'
          name='nom'
          rules={[
            {
              required: true,
              message: 'Entrez le nom',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder="Entrez le nom de l'utilisateur" />
        </Form.Item>
        <Form.Item
          label='Prénom'
          name='prenom'
          rules={[
            {
              required: true,
              message: 'Entrez le prénom',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder="Entrez le prénom de l'utilisateur" />
        </Form.Item>
        <Form.Item
          label='Email'
          name='email'
          rules={[
            {
              required: true,
              message: 'Entrez une adresse mail valide',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder='Entrez une adresse mail valide' />
        </Form.Item>
        <Form.Item
          label='Adresse'
          name='adresse'
          rules={[
            {
              required: true,
              message: "Entrez l'adresse",
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder="Entrez l'adresse" />
        </Form.Item>
        <Form.Item label='Contact' name='mobile' style={{ marginBottom: 5 }}>
          <Input placeholder='Entrez le contact' />
        </Form.Item>
        <Form.Item
          label='Nationalité'
          name='nationalite'
          rules={[
            {
              required: true,
              message: 'Entrez la nationalité',
            },
          ]}
          style={{ marginBottom: 5 }}
        >
          <Input placeholder='Entrez la nationalité' />
        </Form.Item>
        <Form.Item label="Pièce d'intentité" name='piece_identite'>
          <Upload name='piece'>
            <Button icon={<FaUpload style={{ marginRight: 10 }} />}>
              Sélectionnez une pièce d'identité
            </Button>
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
